import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { lighten, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import SearchBar from "material-ui-search-bar";
import Typography from '@material-ui/core/Typography';
import Toolbar from '@material-ui/core/Toolbar';
import TableSortLabel from '@material-ui/core/TableSortLabel';

function descendingComparator(a, b, orderBy) {
    if (a[orderBy] === null) {
        return 1;
    }
    else if (b[orderBy] === null) {
        return -1;
    }
    if (orderBy === 'statusComment' || orderBy === 'name')
        return a[orderBy].toLowerCase().localeCompare(b[orderBy].toLowerCase());
    else if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    else if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}
function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

const headCells = [
    { id: 'did', label: 'Testing Number' },
    { id: 'statusComment', label: 'Comments' },
    { id: 'name', label: 'Pool' }
];

function EnhancedTableHead(props) {
    const { classes, searched, setSearched, setPage, orderBy, onRequestSort, order } = props;

    const handleInput = (searchVal, domain) => {
        setPage(0);
        setSearched({ searched: searchVal, domain: domain });
    }

    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <>
            <TableHead>
                <TableRow>
                    {headCells.map((headCell) => (
                        <TableCell
                            key={headCell.id}
                            align='center'
                            paddingBottom='50px'
                            style={{ fontSize: '1vw', padding: '5px' }}
                            display={'flex'}
                            width={'15%'}
                            float={'center'}
                        >
                            <div class="input-group" style={{ justifyContent: 'center' }}>
                                {headCell.id === "did" &&
                                    <SearchBar
                                        placeholder="Testing Number"
                                        value={searched}
                                        onChange={(searchVal) => handleInput(searchVal, "did")}
                                        onCancelSearch={() => setSearched({ searched: "", domain: "did" })}
                                        style={{ width: '80%', marginBottom: '12px' }}

                                    />
                                }
                                {headCell.id === "name" &&
                                    <SearchBar
                                        placeholder="Pool"
                                        value={searched}
                                        onChange={(searchVal) => handleInput(searchVal, "name")}
                                        onCancelSearch={() => setSearched({ searched: "", domain: "name" })}
                                        style={{ width: '80%', marginBottom: '12px' }}
                                    />
                                }

                                <TableSortLabel
                                    active={orderBy === headCell.id}
                                    direction={orderBy === headCell.id ? order : 'asc'}
                                    onClick={createSortHandler(headCell.id)}
                                >
                                    {headCell.id == "statusComment" &&
                                        <div align='center' style={{ fontSize: '0.9vw' }} >
                                            {headCell.label}
                                        </div>
                                    }
                                    {orderBy === headCell.id ? (
                                        <span className={classes.visuallyHidden}>
                                            {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                        </span>
                                    ) : null}
                                </TableSortLabel>
                            </div>
                        </TableCell>
                    ))}
                </TableRow>
            </TableHead>
        </>
    );
}

const EnhancedTableToolbar = (props) => {
    const classes = useToolbarStyles();
    return (
        <Toolbar className={classes.root}>
            <Typography className={classes.title} variant="h5" id="tableTitle" component="div">
                Testing Numbers
            </Typography>
        </Toolbar>
    );
};

EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired
};

const useToolbarStyles = makeStyles((theme) => ({
    root: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(1)
    },
    highlight:
        theme.palette.type === 'light'
            ? {
                color: theme.palette.secondary.main,
                backgroundColor: lighten(theme.palette.secondary.light, 0.85)
            }
            : {
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.secondary.dark
            },
    title: {
        flex: '1 1 100%',
        margin: 40
    }
}));


const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%'
    },
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2)
    },
    table: {
        minWidth: 750

    },
    buttonGroup: {
        float: 'left',
        padding: '10px 24px'

    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1
    }
}));

export default function TestingNumbersTable({ data: dataObj }) {

    const classes = useStyles();
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = useState('id');
    const [selected, setSelected] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(50);
    const [rows, setRows] = useState(dataObj.testingNums);

    const [searchedObj, setSearched] = useState({ searched: "", domain: "" });

    const handleFilter = () => {
        const filteredRows = rows.filter((row) => {
            if (searchedObj.domain === "did") {
                return row.did
                    .toString()
                    .toLowerCase()
                    .includes(searchedObj.searched.toLowerCase());
            }
            if (searchedObj.domain === "name") {
                return row.name
                    .toString()
                    .toLowerCase()
                    .includes(searchedObj.searched.toLowerCase());
            }
            else return rows
        });
        return filteredRows;
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

    return (
        <>

            <div className={classes.root}>
                <Paper className={classes.paper}>
                    <EnhancedTableToolbar />


                    <TableContainer>
                        <Table
                            className={classes.table}
                            aria-labelledby="tableTitle"
                            size='medium'
                            aria-label="enhanced table"
                        >
                            <EnhancedTableHead
                                classes={classes}
                                numSelected={selected.length}
                                order={order}
                                orderBy={orderBy}
                                onRequestSort={handleRequestSort}
                                setSearched={setSearched}
                                setPage={setPage}
                            />
                            <TableBody>
                                {stableSort(handleFilter(), getComparator(order, orderBy), orderBy)
                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map((row, index) => {
                                        return (
                                            <TableRow
                                                hover
                                                tabIndex={-1}
                                                key={row.id}
                                                style={{ height: '60px', background: (index % 2) ? "#f8f8f8" : "white" }}
                                            >
                                                <TableCell align="center" >{row.did}</TableCell>
                                                <TableCell align="center" >{row.statusComment}</TableCell>
                                                <TableCell align="center" >{row.name}</TableCell>

                                            </TableRow>
                                        );
                                    })}
                                {(emptyRows > 0 && handleFilter().length >= rowsPerPage) && (
                                    <TableRow style={{ height: 60 * emptyRows}}>
                                        <TableCell colSpan={3} />
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePagination
                        rowsPerPageOptions={[10, 50, 100]}
                        component="div"
                        count={rows.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onChangeRowsPerPage={handleChangeRowsPerPage} // Material v < 4
                        onRowsPerPageChange={handleChangeRowsPerPage} // Material v > 4 
                        onPageChange={handleChangePage} // Material v > 4
                        onChangePage={handleChangePage} // Material v < 4 
                    />
                </Paper>

            </div>
        </>
    );

}
